
import api, {STOREFRONT_BANNERS} from '../Api'
import {ICollectionResponse} from "../../models/ICollectionResponse";
import {IStorefrontBanner} from "../../models/Storefront";
import {IActionResponse} from "../../dal/BaseDAL";
import {cloneDeep} from "lodash";

const storefrontBannersApi = api.injectEndpoints({
    endpoints: (build) => ({
        getStorefrontBanners: build.query<ICollectionResponse<IStorefrontBanner>, string>({
            query: (arg) => `storefront/storefronts/${arg}/banners`,
            // The mutations below stay optimistic-only and do not invalidate this tag. It exists so
            // an out-of-band writer (the AI assistant applying a design) can force an open banner
            // editor to refetch.
            providesTags: (_result, _error, storefront) => [{type: STOREFRONT_BANNERS, id: storefront}]
        }),
        saveStorefrontBanner: build.mutation<IActionResponse, {banner: IStorefrontBanner, storefront: string}>({
            query: (arg) => ({
                url:  `storefront/storefronts/${arg.storefront}/banners`,
                method: 'PUT',
                body: arg.banner
            }),
            onQueryStarted: async (arg, {dispatch, queryFulfilled}) => {
                const result = await queryFulfilled;
                if (!result.data.success) {
                    return;
                }

                dispatch(
                    storefrontBannersApi.util.updateQueryData('getStorefrontBanners', arg.storefront, draft => {
                        const copy = cloneDeep(draft);
                        const index = draft.items.findIndex(a => a.id && a.id === arg.banner.id);
                        if (index !== -1) {
                            copy.items.splice(index, 1, arg.banner);
                        } else {
                            if (result.data.id) {
                                arg.banner.id = result.data.id;
                            } else {
                                console.warn('No ID returned from API for new banner');
                            }
                            console.log('current banner', arg.banner);
                            console.log('current items', copy.items);
                            copy.items.splice(copy.items.length, 0, arg.banner);
                            console.log('updated banners', copy.items);
                        }
                        copy.items.sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));
                        console.log('sorted banners', copy.items);
                        Object.assign(draft, copy);
                    })
                );
            }
        }),

        saveStorefrontBanners: build.mutation<IActionResponse, {banners: IStorefrontBanner[], storefront: string}>({
            query: (arg) => ({
                url:  `storefront/storefronts/${arg.storefront}/banners/batch`,
                method: 'PUT',
                body: arg.banners
            }),
            onQueryStarted: async (arg, {dispatch, queryFulfilled}) => {
                const patchResult = dispatch(
                    storefrontBannersApi.util.updateQueryData('getStorefrontBanners', arg.storefront, draft => {
                        const copy = cloneDeep(draft)
                        copy.items = arg.banners
                        copy.total = arg.banners.length
                        Object.assign(draft, copy);
                    })
                );
                try {
                    await queryFulfilled;
                } catch {
                    patchResult.undo();
                }
            }
        }),
        deleteStorefrontBanner: build.mutation<IActionResponse, {storefront: string, id: string}>({
            query: (arg) => ({
                url: `storefront/storefronts/banners/${arg.id}`,
                method: 'DELETE',
            }),
            onQueryStarted: async (arg, {dispatch, queryFulfilled}) => {
                const patchResult = dispatch(
                    storefrontBannersApi.util.updateQueryData('getStorefrontBanners', arg.storefront, draft => {
                        const copy = cloneDeep(draft)
                        const index = draft.items.findIndex(a => a.id === arg.id)
                        if(index !== -1){
                            copy.items.splice(index, 1)
                            Object.assign(draft, copy);
                        }

                    })
                );
                try {
                    await queryFulfilled;
                } catch {
                    patchResult.undo();
                }
            }
        }),
    }),
    overrideExisting: false,
})

export const {
    useGetStorefrontBannersQuery,
    useSaveStorefrontBannerMutation,
    useDeleteStorefrontBannerMutation,
    useSaveStorefrontBannersMutation
} = storefrontBannersApi
